<div class="d-flex justify-content-center align-items-center">
  <app-loading-spinner [isLoading]="true"></app-loading-spinner>
</div>
